(() => {
  console.log('[PF Cart Sync] Script loaded');

  async function refreshCartNotification() {
    const cartNotification = document.querySelector('cart-notification');

    if (!cartNotification) {
      console.warn('[PF Cart Sync] cart-notification not found');
      return;
    }

    if (
      typeof cartNotification.getSectionsToRender !== 'function' ||
      typeof cartNotification.renderContents !== 'function'
    ) {
      console.warn('[PF Cart Sync] CartNotification API unavailable');
      return;
    }

    try {
      const sectionIds = cartNotification
        .getSectionsToRender()
        .map(section => section.id)
        .join(',');

      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}?sections=${encodeURIComponent(sectionIds)}`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) {
        throw new Error(
          `Section request failed: ${response.status}`
        );
      }

      const sections = await response.json();

      console.log('[PF Cart Sync] Sections received', sections);

      cartNotification.renderContents({
        sections,
        item: {}
      });

      console.log('[PF Cart Sync] Cart refreshed');

    } catch (error) {
      console.error('[PF Cart Sync] Refresh failed', error);
    }
  }

  function connectPageFly() {
    const store = window.__pagefly_helper_store__;

    if (!store || typeof store.subscribe !== 'function') {
      return false;
    }

    if (window.__pageflyCartSyncConnected) {
      return true;
    }

    window.__pageflyCartSyncConnected = true;

    store.subscribe(() => {
      console.log('[PF Cart Sync] PageFly cart update detected');

      refreshCartNotification();
    });

    console.log('[PF Cart Sync] Connected to PageFly');

    return true;
  }

  if (!connectPageFly()) {
    const interval = setInterval(() => {
      if (connectPageFly()) {
        clearInterval(interval);
      }
    }, 200);

    setTimeout(() => {
      clearInterval(interval);
    }, 10000);
  }
})();